import type { GridSeatDenominated } from '@/lib/data-sources';

const STABLECOIN_TOKENS = new Set([
  '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC (Base)
  '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6b1', // USDbC
  '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2', // USDT
]);

/**
 * Sum V2 grid seat self-assessed value in USDC 6dp micro-units.
 * (Same math as the client; keep in sync for leaderboard ranking.)
 */
export function sumV2GridSeatsToUsdc6(
  seats: GridSeatDenominated[],
  takeoverPriceUsd: number,
): bigint {
  let total = 0n;
  for (const seat of seats) {
    const price = BigInt(seat.selfAssessedPrice || '0');
    if (price === 0n) continue;
    if (STABLECOIN_TOKENS.has(seat.taxToken)) {
      if (seat.taxTokenDecimals === 6) {
        total += price;
      } else {
        total += BigInt(
          Math.floor((Number(price) / 10 ** seat.taxTokenDecimals) * 1e6),
        );
      }
    } else {
      total += BigInt(
        Math.floor(
          (Number(price) / 10 ** seat.taxTokenDecimals) * takeoverPriceUsd * 1e6,
        ),
      );
    }
  }
  return total;
}
